'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');

mmWidgets.fn.showProgressMessage = function (message) {
	const widget = this;
	widget.find('[data-mm-role~="progress-message"]').text(message);
	widget.showSection('progress');
};
